import React from 'react';
import { Grid, Typography } from '@material-ui/core';
import PropTypes from 'prop-types';
import { uniqueId } from 'lodash';

import useStyles from './makeStyles';

const Details = ({ details }) => {
  const classes = useStyles();
  return (
    <>
      {details
        .filter(({ label, value, hasInteractiveLabel }) => label || value || hasInteractiveLabel) // Filter non-empty objects
        .map(({ label, value, hasInteractiveLabel = false }) => (
          <Grid container direction="row" key={uniqueId()} spacing={2}>
            <Grid item xs={7} className={classes.label}>
              {hasInteractiveLabel ? label : <Typography>{label}</Typography>}
            </Grid>
            <Grid item xs={5} className={classes.valueContainer}>
              {value}
            </Grid>
          </Grid>
        ))}
    </>
  );
};

Details.propTypes = {
  details: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      value: PropTypes.node,
    }),
  ).isRequired,
};

export default Details;
